/** Auth, dashboard, admin, mentors — merged into each locale via translations.js */
import { callbackStatusLabels } from "./helpAgentStrings";

export const legalStatuses = ["submitted", "in_review", "in_process", "resolved"];

const legalStatusLabels = {
  en: {
    submitted: "Submitted",
    in_review: "In review",
    in_process: "In process",
    resolved: "Resolved",
    under_review: "In review",
    closed: "Resolved",
  },
  hi: {
    submitted: "जमा",
    in_review: "समीक्षा में",
    in_process: "प्रक्रिया में",
    resolved: "निपटाया",
    under_review: "समीक्षा में",
    closed: "निपटाया",
  },
  te: {
    submitted: "సమర్పించబడింది",
    in_review: "సమీక్షలో",
    in_process: "ప్రక్రియలో",
    resolved: "పరిష్కరించబడింది",
    under_review: "సమీక్షలో",
    closed: "పరిష్కరించబడింది",
  },
  ta: {
    submitted: "சமர்ப்பிக்கப்பட்டது",
    in_review: "மதிப்பீட்டில்",
    in_process: "செயல்பாட்டில்",
    resolved: "தீர்க்கப்பட்டது",
    under_review: "மதிப்பீட்டில்",
    closed: "தீர்க்கப்பட்டது",
  },
  bn: {
    submitted: "জমা দেওয়া",
    in_review: "পর্যালোচনায়",
    in_process: "প্রক্রিয়াধীন",
    resolved: "সমাধান",
    under_review: "পর্যালোচনায়",
    closed: "সমাধান",
  },
  mr: {
    submitted: "सादर",
    in_review: "पुनरावलोकनात",
    in_process: "प्रक्रियेत",
    resolved: "निराकरण",
    under_review: "पुनरावलोकनात",
    closed: "निराकरण",
  },
  kn: {
    submitted: "ಸಲ್ಲಿಸಲಾಗಿದೆ",
    in_review: "ಪರಿಶೀಲನೆಯಲ್ಲಿ",
    in_process: "ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ",
    resolved: "ಪರಿಹರಿಸಲಾಗಿದೆ",
    under_review: "ಪರಿಶೀಲನೆಯಲ್ಲಿ",
    closed: "ಪರಿಹರಿಸಲಾಗಿದೆ",
  },
  ml: {
    submitted: "സമർപ്പിച്ചു",
    in_review: "പരിശോധനയിൽ",
    in_process: "പ്രക്രിയയിൽ",
    resolved: "പരിഹരിച്ചു",
    under_review: "പരിശോധനയിൽ",
    closed: "പരിഹരിച്ചു",
  },
  pa: {
    submitted: "ਜਮ੍ਹਾਂ",
    in_review: "ਸਮੀਖਿਆ ਵਿੱਚ",
    in_process: "ਪ੍ਰਕਿਰਿਆ ਵਿੱਚ",
    resolved: "ਹੱਲ",
    under_review: "ਸਮੀਖਿਆ ਵਿੱਚ",
    closed: "ਹੱਲ",
  },
};

export const statusLabel = (lang, code) =>
  legalStatusLabels[lang]?.[code] || legalStatusLabels.en[code] || code;

export const appStrings = {
  en: {
    lang: { choose: "Choose Language" },
    lossCategories: {
      eyebrow: "Choose Your Path",
      title: "What financial loss are you fighting?",
      subtitle: "Find the right authority. Prepare the right evidence. Take the right next step.",
      authorityLabel: "Where to complain",
      items: [
        { key: "trading", title: "Trading & Investment Fraud", desc: "Brokers, advisors, Telegram tips, fake demat handling, guaranteed-return schemes.", authority: "SEBI SCORES / SMART ODR" },
        { key: "consumer", title: "Consumer Product & Service", desc: "Online and offline shopping — defective products, missing orders, refund denials, and unfair trade practices.", authority: "National Consumer Helpline" },
        { key: "airline", title: "Airline Refund & Delay", desc: "Refunds, cancellations, flight delays and lost or damaged baggage.", authority: "AirSewa / DGCA" },
        { key: "banking", title: "Banking, UPI, Card & Loan", desc: "Unauthorised debits, UPI fraud, card misuse, loan & NBFC disputes.", authority: "RBI" },
        { key: "cyber", title: "Cyber Fraud & Scam Payments", desc: "Online scams, phishing, fraudulent transfers and digital payment fraud.", authority: "Cybercrime Portal / 1930" },
        { key: "insurance", title: "Insurance Claim Disputes", desc: "Rejected claims, mis-selling, delayed settlements and policy grievances.", authority: "IRDAI" },
        { key: "housing", title: "Housing Finance Complaints", desc: "Home-loan and housing-finance company grievances.", authority: "NHB" },
        { key: "pension", title: "Pension Grievances", desc: "NPS, pension account and retirement-fund related issues.", authority: "PFRDA" },
        { key: "other", title: "Other Financial Loss", desc: "Chit funds, MLM, job fraud, crypto, loan-app harassment — any loss not listed above.", authority: "Varies by case" },
      ],
    },
    lossGuide: {
      officialTitle: "How to report on the official portal",
      openPortal: "Open",
      evidenceTitle: "Evidence to gather before filing",
      disclaimer: "CHINTAMAT is not a government body or law firm. We guide you to official channels and help document your case.",
      teamHelpTitle: "Need CHINTAMAT team help?",
      teamHelpDesc: "If you want our team to review your case, help prepare evidence, or guide your next step — submit the form below. Your details go to our admin team for review.",
      teamHelpBtn: "Get CHINTAMAT team help",
      name: "Your name",
      email: "Email",
      phone: "Phone",
      optional: "optional",
      amountLost: "Amount lost (INR)",
      categoryDetails: "Details for this type of loss",
      description: "What happened",
      descriptionPlaceholder: "Dates, amounts, reference numbers, and what you need help with…",
      callFromAgent: "Someone claiming to be a lawyer, police officer, or recovery agent contacted me about this case",
      submit: "Submit to CHINTAMAT team",
      success: "Request received. Our team will review it shortly.",
      viewDashboard: "View my requests on dashboard →",
      nameRequired: "Name is required",
      phoneRequired: "Phone number is required",
      isRequired: "is required",
      select: "Select…",
    },
    auth: {
      welcomeBack: "Welcome back",
      signInSubtitle: "Sign in to write reviews, track cases, and save mentors.",
      joinTitle: "Join CHINTAMAT",
      joinSubtitle: "Create an account to report scams, request legal guidance, and use the mentor directory.",
      joinSubtitleShort: "Help protect Indian traders — review, report, expose.",
      signingUpAs: "I am signing up as",
      minPassword: "Minimum 6 characters",
      email: "Email",
      password: "Password",
      name: "Full name",
      signIn: "Sign in",
      signUp: "Create account",
      continueGoogle: "Continue with Google",
      orEmail: "or email",
      newHere: "New to CHINTAMAT?",
      haveAccount: "Already have an account?",
      createAccount: "Create an account",
      gotoSignIn: "Sign in",
      passwordMin: "Password must be at least 6 characters",
      roleUser: "Individual",
      roleUserDesc: "I'm a trader / victim looking to report or research.",
      roleMentor: "Mentor / Educator",
      roleMentorDesc: "I run a course, channel, or paid mentorship.",
      roleAdvisory: "Research Analyst / Advisory",
      roleAdvisoryDesc: "I'm a SEBI-registered RIA, RA, or research firm.",
      verifying: "Verifying session…",
      signingIn: "Signing you in…",
      adminRequired: "Admin access required.",
      adminForbiddenDesc: "Your account does not have admin privileges.",
    },
    dashboard: {
      eyebrow: "My Dashboard",
      hello: "Hello",
      adminPanel: "Admin Panel",
      adminDesc: "Manage users, scam reports, legal help, and blog content.",
      openAdmin: "Open admin",
      statReviews: "Reviews written",
      statCases: "Cases reported",
      statLegal: "Legal help asked",
      statSaved: "Saved mentors",
      tabReviews: "My Reviews",
      tabCases: "My Cases",
      tabSaved: "Saved Mentors",
      tabLegal: "Legal Help",
      emptyReviews: "You haven't written any reviews yet.",
      browseMentors: "Browse mentors",
      emptyCases: "No cases yet.",
      reportScam: "Report a scam",
      emptySaved: "No saved mentors.",
      discoverMentors: "Discover mentors",
      emptyLegal: "No legal help requests yet.",
      submitLegal: "Submit a request",
      agentContact: "Agent contact reported",
      viewProfile: "View profile",
      recentActivity: "Recent updates",
      openCase: "Open case",
      prefsTitle: "Notification preferences",
      prefsBlog: "New blog & education articles",
      prefsCase: "Case status updates & staff replies",
      prefsSaved: "Preferences saved",
    },
    notifications: {
      title: "Notifications",
      empty: "No notifications yet",
      markAllRead: "Mark all read",
      viewDashboard: "Open dashboard",
      types: {
        case_status_change: {
          title: "{caseLabel} status updated",
          body: "Your case is now: {status}",
        },
        case_staff_comment: {
          title: "Reply from CHINTAMAT",
          body: "{authorName}: {preview}",
        },
        case_user_comment: {
          title: "User commented — {caseLabel}",
          body: "{authorName}: {preview}",
        },
        case_internal_note: {
          title: "Internal note — {caseLabel}",
          body: "{authorName}: {preview}",
        },
        new_scam_report: {
          title: "New scam report",
          body: "{scamType} — open in staff panel",
        },
        new_legal_request: {
          title: "New legal help request",
          body: "{lossType} — {name}",
        },
        blog_published: {
          title: "New article",
          body: "{articleTitle}",
        },
        comment: { title: "Case update", body: "{preview}" },
        status_change: { title: "Status updated", body: "Your case status changed" },
        case_created: { title: "New submission", body: "Review in admin panel" },
      },
    },
    caseWorkspace: {
      evidenceTitle: "Evidence checklist",
      statusTimeline: "Status timeline",
      comments: "Comments",
      sendMessage: "Send message",
      postComment: "Post comment",
      noComments: "No comments yet. CHINTAMAT staff will reply here.",
      userCommentHint: "Your message will be visible to CHINTAMAT staff.",
      staffCommentHint: "Public comments are visible to the user. Internal notes are staff-only.",
      publicVis: "Public (user can see)",
      internalVis: "Internal only",
      loading: "Loading case…",
      notFound: "Case not found",
      caseUpdated: "Case updated",
      commentPosted: "Comment posted",
      checklist: {
        screenshots: "Chat or screenshot proof",
        payment_proof: "UPI / bank payment proof",
        platform_profile: "Scammer profile or channel links",
        contract: "Invoice or agreement",
        id_proof: "Government ID",
        loss_proof: "Loss / transaction proof",
        communication: "Emails or chats with entity",
        legal_notice: "Prior legal notice (if any)",
      },
    },
    admin: {
      title: "Admin Panel",
      subtitle: "Manage users, scam reports, legal help, and blog content for CHINTAMAT.",
      loading: "Loading…",
      refresh: "Refresh",
      overview: "Overview",
      users: "Users",
      scamReports: "Scam Reports",
      lossRequests: "Loss Requests",
      blog: "Blog",
      allStatuses: "All statuses",
      allCategories: "All categories",
      category: "Category",
      searchLegal: "Search email, name, loss type…",
      noLegal: "No legal help requests.",
      contact: "Contact",
      lossType: "Loss type",
      amount: "Amount",
      status: "Status",
      submitted: "Submitted",
      actions: "Actions",
      view: "View",
      legalDetail: "Legal help request",
      adminNotes: "Admin notes",
      saveNotes: "Save notes",
      markResolved: "Mark resolved",
      closeRequest: "Close",
      statusUpdated: "Status updated",
      notesSaved: "Notes saved",
      changeStatus: "Change status",
      pendingLegal: "pending",
      reportsSection: "Reports & Mentors",
      contentSection: "Content & Inbox",
      usersSection: "Users",
      total: "Total",
      individuals: "Individuals",
      mentors: "Mentors",
      advisories: "Advisories",
      admins: "Admins",
      blocked: "Blocked",
      reports: "Reports",
      pending: "Pending",
      published: "Published",
      totalLoss: "Total Loss (₹)",
      acrossReports: "Across all reports",
      verified: "verified",
      flagged: "flagged",
      reviews: "Reviews",
      articles: "Articles",
      contactMessages: "Contact messages",
      legalRequests: "Legal requests",
      needHelp: "Need Help",
      callbackRequests: "Callback requests",
      searchCallback: "Search name, email, phone…",
      noCallback: "No callback requests yet.",
      phone: "Phone",
      callbackDetail: "Callback request",
      callbackStatus: callbackStatusLabels.en,
      legalStatus: legalStatusLabels.en,
    },
    mentors: {
      eyebrow: "Trust Platform",
      title: "Discover Verified Mentors",
      subtitle:
        "Search, compare, and review India's stock market mentors and educators. Every profile carries an evidence-based CHINTAMAT TRUST SCORE™.",
      search: "Search by name, company, category…",
      category: "Category",
      allCategories: "All categories",
      verification: "Verification",
      all: "All",
      verifiedOnly: "Verified only",
      unverified: "Unverified",
      sortTrust: "Top Trust Score",
      sortRating: "Highest Rated",
      sortReviews: "Most reviews",
      sortRecent: "Recently added",
      noResults: "No mentors match your filters.",
      viewProfile: "View profile",
      view: "View",
      reviews: "reviews",
      loading: "Loading…",
      verified: "Verified",
      flagged: "Flagged",
    },
    blog: {
      eyebrow: "Investigations · Stories · Playbooks",
      title: "Blog — Real Cases, Legal Playbooks",
      subtitle:
        "Real scam cases, step-by-step legal filings, and lessons collected from verified victim accounts across India.",
      allStories: "All Stories",
      featured: "Featured",
      readFull: "Read in full",
      readArticle: "Read full article",
      collapse: "Collapse",
      emptyCategory: "No articles in this category yet.",
      ctaTitle: "Have a story to share?",
      ctaBody:
        "Anonymous victim stories help thousands. Submit yours and our team will research, verify, and publish a public case study (without exposing your identity).",
      ctaButton: "Submit a Case",
    },
    protected: {
      loading: "Verifying session…",
      adminLoading: "Checking admin access…",
    },
  },
  hi: {
    lang: { choose: "भाषा चुनें" },
    lossCategories: {
      eyebrow: "अपना रास्ता चुनें",
      title: "आप किस वित्तीय नुकसान से लड़ रहे हैं?",
      subtitle: "सही अथॉरिटी खोजें। सही सबूत तैयार करें। सही अगला कदम उठाएँ।",
      authorityLabel: "कहाँ शिकायत करें",
      items: [
        { key: "trading", title: "ट्रेडिंग और निवेश धोखाधड़ी", desc: "ब्रोकर, सलाहकार, टेलीग्राम टिप्स, फर्जी डीमैट हैंडलिंग, गारंटीड रिटर्न योजनाएँ।", authority: "SEBI SCORES / SMART ODR" },
        { key: "consumer", title: "उपभोक्ता उत्पाद और सेवा", desc: "दोषपूर्ण उत्पाद, खराब सेवाएँ और अनुचित व्यापार व्यवहार।", authority: "राष्ट्रीय उपभोक्ता हेल्पलाइन" },
        { key: "airline", title: "एयरलाइन रिफंड और देरी", desc: "रिफंड, रद्दीकरण, उड़ान में देरी और खोया/क्षतिग्रस्त सामान।", authority: "AirSewa / DGCA" },
        { key: "banking", title: "बैंकिंग, UPI, कार्ड और लोन", desc: "अनधिकृत डेबिट, UPI धोखाधड़ी, कार्ड दुरुपयोग, लोन और NBFC विवाद।", authority: "RBI" },
        { key: "cyber", title: "साइबर धोखाधड़ी और स्कैम भुगतान", desc: "ऑनलाइन स्कैम, फ़िशिंग, धोखाधड़ी वाले ट्रांसफर और डिजिटल भुगतान धोखाधड़ी।", authority: "साइबर क्राइम पोर्टल / 1930" },
        { key: "insurance", title: "बीमा क्लेम विवाद", desc: "अस्वीकृत क्लेम, गलत बिक्री, विलंबित भुगतान और पॉलिसी शिकायतें।", authority: "IRDAI" },
        { key: "housing", title: "हाउसिंग फाइनेंस शिकायतें", desc: "होम-लोन और हाउसिंग फाइनेंस कंपनी से जुड़ी शिकायतें।", authority: "NHB" },
        { key: "pension", title: "पेंशन शिकायतें", desc: "NPS, पेंशन खाता और रिटायरमेंट फंड संबंधी मुद्दे।", authority: "PFRDA" },
      ],
    },
    auth: {
      welcomeBack: "वापसी पर स्वागत",
      signInSubtitle: "समीक्षा लिखने, केस ट्रैक करने और मेंटर सेव करने के लिए साइन इन करें।",
      joinTitle: "CHINTAMAT से जुड़ें",
      joinSubtitle: "स्कैम रिपोर्ट, कानूनी मार्गदर्शन और मेंटर डायरेक्टरी के लिए खाता बनाएं।",
      joinSubtitleShort: "भारतीय ट्रेडरों की सुरक्षा — समीक्षा, रिपोर्ट, पर्दाफाश।",
      signingUpAs: "मैं इस रूप में पंजीकरण कर रहा/रही हूँ",
      minPassword: "कम से कम 6 अक्षर",
      email: "ईमेल",
      password: "पासवर्ड",
      name: "पूरा नाम",
      signIn: "साइन इन",
      signUp: "खाता बनाएं",
      continueGoogle: "Google से जारी रखें",
      orEmail: "या ईमेल",
      newHere: "CHINTAMAT पर नए हैं?",
      haveAccount: "पहले से खाता है?",
      createAccount: "खाता बनाएं",
      gotoSignIn: "साइन इन",
      passwordMin: "पासवर्ड कम से कम 6 अक्षर का हो",
      roleUser: "व्यक्तिगत",
      roleUserDesc: "मैं ट्रेडर / पीड़ित हूँ — रिपोर्ट या शोध के लिए।",
      roleMentor: "मेंटर / शिक्षक",
      roleMentorDesc: "मैं कोर्स, चैनल या पेड मेंटरशिप चलाता/चलाती हूँ।",
      roleAdvisory: "रिसर्च एनालिस्ट / एडवाइजरी",
      roleAdvisoryDesc: "मैं SEBI-पंजीकृत RIA, RA या फर्म हूँ।",
      verifying: "सत्र जाँच हो रही है…",
      adminRequired: "एडमिन एक्सेस आवश्यक।",
    },
    dashboard: {
      eyebrow: "मेरा डैशबोर्ड",
      hello: "नमस्ते",
      adminPanel: "एडमिन पैनल",
      adminDesc: "उपयोगकर्ता, स्कैम रिपोर्ट, कानूनी सहायता और ब्लॉग प्रबंधित करें।",
      openAdmin: "एडमिन खोलें",
      statReviews: "लिखी समीक्षाएँ",
      statCases: "रिपोर्ट किए केस",
      statLegal: "कानूनी सहायता अनुरोध",
      statSaved: "सेव किए मेंटर",
      tabReviews: "मेरी समीक्षाएँ",
      tabCases: "मेरे केस",
      tabSaved: "सेव मेंटर",
      tabLegal: "कानूनी सहायता",
      emptyReviews: "अभी कोई समीक्षा नहीं।",
      browseMentors: "मेंटर देखें",
      emptyCases: "अभी कोई केस नहीं।",
      reportScam: "स्कैम रिपोर्ट करें",
      emptySaved: "कोई सेव मेंटर नहीं।",
      discoverMentors: "मेंटर खोजें",
      emptyLegal: "अभी कोई कानूनी अनुरोध नहीं।",
      submitLegal: "अनुरोध भेजें",
      agentContact: "एजेंट संपर्क की सूचना",
      viewProfile: "प्रोफ़ाइल देखें",
      recentActivity: "हाल की अपडेट",
      openCase: "केस खोलें",
      prefsTitle: "सूचना प्राथमिकताएँ",
      prefsBlog: "नए ब्लॉग और शिक्षा लेख",
      prefsCase: "केस स्थिति और स्टाफ जवाब",
      prefsSaved: "प्राथमिकताएँ सेव",
    },
    notifications: {
      title: "सूचनाएँ",
      empty: "अभी कोई सूचना नहीं",
      markAllRead: "सभी पढ़ा चिह्नित करें",
      viewDashboard: "डैशबोर्ड खोलें",
      types: {
        case_status_change: { title: "{caseLabel} — स्थिति अपडेट", body: "आपका केस अब: {status}" },
        case_staff_comment: { title: "CHINTAMAT से जवाब", body: "{authorName}: {preview}" },
        case_user_comment: { title: "उपयोगकर्ता टिप्पणी — {caseLabel}", body: "{authorName}: {preview}" },
        case_internal_note: { title: "आंतरिक नोट — {caseLabel}", body: "{authorName}: {preview}" },
        new_scam_report: { title: "नई स्कैम रिपोर्ट", body: "{scamType} — एडमिन में देखें" },
        new_legal_request: { title: "नया कानूनी अनुरोध", body: "{lossType} — {name}" },
        blog_published: { title: "नया लेख", body: "{articleTitle}" },
      },
    },
    caseWorkspace: {
      evidenceTitle: "साक्ष्य चेकलिस्ट",
      statusTimeline: "स्थिति समयरेखा",
      comments: "टिप्पणियाँ",
      sendMessage: "संदेश भेजें",
      postComment: "टिप्पणी पोस्ट करें",
      noComments: "अभी कोई टिप्पणी नहीं। CHINTAMAT स्टाफ यहाँ जवाब देगा।",
      userCommentHint: "आपका संदेश CHINTAMAT स्टाफ को दिखेगा।",
      staffCommentHint: "सार्वजनिक टिप्पणियाँ उपयोगकर्ता को दिखती हैं। आंतरिक नोट केवल स्टाफ के लिए।",
      publicVis: "सार्वजनिक (उपयोगकर्ता देख सकता है)",
      internalVis: "केवल आंतरिक",
      loading: "केस लोड हो रहा है…",
      notFound: "केस नहीं मिला",
      caseUpdated: "केस अपडेट",
      commentPosted: "टिप्पणी पोस्ट",
      checklist: {
        screenshots: "चैट या स्क्रीनशॉट प्रमाण",
        payment_proof: "UPI / बैंक भुगतान प्रमाण",
        platform_profile: "स्कैमर प्रोफ़ाइल लिंक",
        contract: "चालान या अनुबंध",
        id_proof: "सरकारी पहचान पत्र",
        loss_proof: "हानि / लेनदेन प्रमाण",
        communication: "ईमेल या चैट",
        legal_notice: "पूर्व कानूनी नोटिस (यदि कोई)",
      },
    },
    admin: {
      title: "एडमिन पैनल",
      subtitle: "CHINTAMAT के उपयोगकर्ता, स्कैम रिपोर्ट, कानूनी सहायता और ब्लॉग प्रबंधित करें।",
      loading: "लोड हो रहा है…",
      refresh: "रीफ़्रेश",
      overview: "अवलोकन",
      users: "उपयोगकर्ता",
      scamReports: "स्कैम रिपोर्ट",
      legalHelp: "कानूनी सहायता",
      blog: "ब्लॉग",
      allStatuses: "सभी स्थिति",
      allCategories: "सभी श्रेणियाँ",
      category: "श्रेणी",
      searchLegal: "ईमेल, नाम, हानि प्रकार खोजें…",
      noLegal: "कोई कानूनी अनुरोध नहीं।",
      contact: "संपर्क",
      lossType: "हानि प्रकार",
      amount: "राशि",
      status: "स्थिति",
      submitted: "जमा",
      actions: "कार्रवाई",
      view: "देखें",
      legalDetail: "कानूनी सहायता अनुरोध",
      adminNotes: "एडमिन नोट्स",
      saveNotes: "नोट्स सेव करें",
      markResolved: "निपटाया चिह्नित करें",
      closeRequest: "बंद करें",
      statusUpdated: "स्थिति अपडेट",
      notesSaved: "नोट्स सेव",
      changeStatus: "स्थिति बदलें",
      pendingLegal: "लंबित",
      reportsSection: "रिपोर्ट और मेंटर",
      contentSection: "सामग्री और इनबॉक्स",
      usersSection: "उपयोगकर्ता",
      total: "कुल",
      individuals: "व्यक्ति",
      mentors: "मेंटर",
      advisories: "एडवाइजरी",
      admins: "एडमिन",
      blocked: "ब्लॉक",
      reports: "रिपोर्ट",
      pending: "लंबित",
      published: "प्रकाशित",
      totalLoss: "कुल हानि (₹)",
      acrossReports: "सभी रिपोर्ट में",
      verified: "सत्यापित",
      flagged: "फ़्लैग",
      reviews: "समीक्षाएँ",
      articles: "लेख",
      contactMessages: "संपर्क संदेश",
      legalRequests: "कानूनी अनुरोध",
      legalStatus: legalStatusLabels.hi,
    },
    mentors: {
      title: "मेंटर डायरेक्टरी",
      subtitle: "भुगतान से पहले मेंटर की जाँच करें। समीक्षाएँ पंजीकृत उपयोगकर्ताओं से हैं — SEBI पंजीकरण स्वयं सत्यापित करें।",
      search: "नाम, कंपनी, शहर खोजें…",
      category: "श्रेणी",
      allCategories: "सभी श्रेणियाँ",
      verification: "सत्यापन",
      all: "सभी",
      verifiedOnly: "केवल सत्यापित",
      unverified: "असत्यापित",
      sortTrust: "उच्चतम विश्वास",
      sortReviews: "सबसे अधिक समीक्षा",
      sortRecent: "हाल में जोड़े",
      noResults: "कोई मेंटर मेल नहीं खाता।",
      viewProfile: "प्रोफ़ाइल देखें",
      reviews: "समीक्षाएँ",
    },
    blog: {
      title: "ब्लॉग — सच्चे मामले, कानूनी मार्गदर्शन",
      subtitle: "सत्यापित पीड़ितों के अनुभव, कानूनी शिकायत चरण और सबक — भारत भर से।",
    },
    protected: { loading: "सत्र जाँच…", adminLoading: "एडमिन एक्सेस जाँच…" },
  },
  te: {
    lang: { choose: "భాష ఎంచుకోండి" },
    lossCategories: {
      eyebrow: "మీ మార్గాన్ని ఎంచుకోండి",
      title: "మీరు ఏ ఆర్థిక నష్టంతో పోరాడుతున్నారు?",
      subtitle: "సరైన అధికారాన్ని కనుగొనండి. సరైన సాక్ష్యాన్ని సిద్ధం చేయండి. సరైన తదుపరి అడుగు వేయండి.",
      authorityLabel: "ఎక్కడ ఫిర్యాదు చేయాలి",
      items: [
        { key: "trading", title: "ట్రేడింగ్ & పెట్టుబడి మోసం", desc: "బ్రోకర్లు, సలహాదారులు, టెలిగ్రామ్ టిప్‌లు, నకిలీ డీమ్యాట్ నిర్వహణ, గ్యారెంటీడ్ రాబడి పథకాలు.", authority: "SEBI SCORES / SMART ODR" },
        { key: "consumer", title: "వినియోగదారు ఉత్పత్తి & సేవ", desc: "లోపభూయిష్ట ఉత్పత్తులు, లోపభూయిష్ట సేవలు మరియు అన్యాయమైన వాణిజ్య పద్ధతులు.", authority: "జాతీయ వినియోగదారు హెల్ప్‌లైన్" },
        { key: "airline", title: "విమాన రీఫండ్ & ఆలస్యం", desc: "రీఫండ్‌లు, రద్దులు, విమాన ఆలస్యం మరియు కోల్పోయిన/పాడైన సామాను.", authority: "AirSewa / DGCA" },
        { key: "banking", title: "బ్యాంకింగ్, UPI, కార్డు & లోన్", desc: "అనధికార డెబిట్‌లు, UPI మోసం, కార్డు దుర్వినియోగం, లోన్ & NBFC వివాదాలు.", authority: "RBI" },
        { key: "cyber", title: "సైబర్ మోసం & స్కామ్ చెల్లింపులు", desc: "ఆన్‌లైన్ స్కామ్‌లు, ఫిషింగ్, మోసపూరిత బదిలీలు మరియు డిజిటల్ చెల్లింపు మోసం.", authority: "సైబర్ క్రైమ్ పోర్టల్ / 1930" },
        { key: "insurance", title: "భీమా క్లెయిమ్ వివాదాలు", desc: "తిరస్కరించబడిన క్లెయిమ్‌లు, తప్పుడు అమ్మకం, ఆలస్యమైన పరిష్కారాలు మరియు పాలసీ ఫిర్యాదులు.", authority: "IRDAI" },
        { key: "housing", title: "హౌసింగ్ ఫైనాన్స్ ఫిర్యాదులు", desc: "హోమ్-లోన్ మరియు హౌసింగ్ ఫైనాన్స్ కంపెనీ ఫిర్యాదులు.", authority: "NHB" },
        { key: "pension", title: "పెన్షన్ ఫిర్యాదులు", desc: "NPS, పెన్షన్ ఖాతా మరియు రిటైర్‌మెంట్ ఫండ్ సంబంధిత సమస్యలు.", authority: "PFRDA" },
      ],
    },
    auth: {
      welcomeBack: "మళ్ళీ స్వాగతం",
      signInSubtitle: "రివ్యూలు రాయడం, కేసులు ట్రాక్ చేయడం, మెంటర్లు సేవ్ చేయడానికి సైన్ ఇన్ చేయండి.",
      joinTitle: "CHINTAMAT లో చేరండి",
      joinSubtitle: "స్కామ్ రిపోర్ట్, చట్టపరమైన మార్గదర్శనం, మెంటర్ డైరెక్టరీ కోసం ఖాతా సృష్టించండి.",
      email: "ఇమెయిల్",
      password: "పాస్‌వర్డ్",
      name: "పూర్తి పేరు",
      signIn: "సైన్ ఇన్",
      signUp: "ఖాతా సృష్టించండి",
      continueGoogle: "Google తో కొనసాగించండి",
      orEmail: "లేదా ఇమెయిల్",
      newHere: "CHINTAMAT కు కొత్తవారా?",
      haveAccount: "ఇప్పటికే ఖాతా ఉందా?",
      createAccount: "ఖాతా సృష్టించండి",
      gotoSignIn: "సైన్ ఇన్",
      passwordMin: "పాస్‌వర్డ్ కనీసం 6 అక్షరాలు",
      roleUser: "వ్యక్తి",
      roleUserDesc: "ట్రేడర్ / బాధితుడిని — రిపోర్ట్ లేదా పరిశోధన.",
      roleMentor: "మెంటర్ / ఎడ్యుకేటర్",
      roleMentorDesc: "కోర్సు, ఛానెల్ లేదా పేయిడ్ మెంటర్‌షిప్.",
      roleAdvisory: "రిసెర్చ్ అనలిస్ట్",
      roleAdvisoryDesc: "SEBI నమోదిత RIA, RA లేదా సంస్థ.",
      verifying: "సెషన్ తనిఖీ…",
      adminRequired: "అడ్మిన్ యాక్సెస్ అవసరం.",
    },
    dashboard: {
      eyebrow: "నా డ్యాష్‌బోర్డ్",
      hello: "హలో",
      adminPanel: "అడ్మిన్ ప్యానెల్",
      adminDesc: "యూజర్లు, స్కామ్ రిపోర్ట్లు, చట్టపరమైన సహాయం, బ్లాగ్ నిర్వహించండి.",
      openAdmin: "అడ్మిన్ తెరవండి",
      statReviews: "రాసిన రివ్యూలు",
      statCases: "రిపోర్ట్ చేసిన కేసులు",
      statLegal: "చట్టపరమైన సహాయం అభ్యర్థనలు",
      statSaved: "సేవ్ చేసిన మెంటర్లు",
      tabReviews: "నా రివ్యూలు",
      tabCases: "నా కేసులు",
      tabSaved: "సేవ్ మెంటర్లు",
      tabLegal: "చట్టపరమైన సహాయం",
      emptyReviews: "ఇంకా రివ్యూలు లేవు.",
      browseMentors: "మెంటర్లు చూడండి",
      emptyCases: "ఇంకా కేసులు లేవు.",
      reportScam: "స్కామ్ రిపోర్ట్",
      emptySaved: "సేవ్ మెంటర్లు లేవు.",
      discoverMentors: "మెంటర్లు కనుగొనండి",
      emptyLegal: "ఇంకా చట్టపరమైన అభ్యర్థనలు లేవు.",
      submitLegal: "అభ్యర్థన పంపండి",
      agentContact: "ఏజెంట్ సంప్రదింపు నమోదు",
      viewProfile: "ప్రొఫైల్ చూడండి",
      recentActivity: "ఇటీవలి అప్‌డేట్‌లు",
      openCase: "కేస్ తెరవండి",
      prefsTitle: "నోటిఫికేషన్ ప్రాధాన్యతలు",
      prefsBlog: "కొత్త బ్లాగ్ & విద్యా వ్యాసాలు",
      prefsCase: "కేస్ స్థితి & స్టాఫ్ స్పందన",
      prefsSaved: "ప్రాధాన్యతలు సేవ్",
    },
    notifications: {
      title: "నోటిఫికేషన్‌లు",
      empty: "ఇంకా నోటిఫికేషన్‌లు లేవు",
      markAllRead: "అన్నీ చదివినవిగా గుర్తు",
      viewDashboard: "డ్యాష్‌బోర్డ్ తెరవండి",
      types: {
        case_status_change: { title: "{caseLabel} — స్థితి అప్‌డేట్", body: "మీ కేస్ ఇప్పుడు: {status}" },
        case_staff_comment: { title: "CHINTAMAT నుండి స్పందన", body: "{authorName}: {preview}" },
        case_user_comment: { title: "వినియోగదారు వ్యాఖ్య — {caseLabel}", body: "{authorName}: {preview}" },
        new_scam_report: { title: "కొత్త స్కామ్ రిపోర్ట్", body: "{scamType}" },
        new_legal_request: { title: "కొత్త లీగల్ అభ్యర్థన", body: "{lossType} — {name}" },
        blog_published: { title: "కొత్త వ్యాసం", body: "{articleTitle}" },
      },
    },
    caseWorkspace: {
      evidenceTitle: "సాక్ష్య చెక్‌లిస్ట్",
      statusTimeline: "స్థితి కాలరేఖ",
      comments: "వ్యాఖ్యలు",
      sendMessage: "సందేశం పంపండి",
      postComment: "వ్యాఖ్య పోస్ట్",
      noComments: "ఇంకా వ్యాఖ్యలు లేవు. CHINTAMAT స్టాఫ్ ఇక్కడ స్పందిస్తారు.",
      loading: "కేస్ లోడ్…",
      checklist: {
        screenshots: "చాట్ లేదా స్క్రీన్‌షాట్",
        payment_proof: "UPI / బ్యాంక్ చెల్లింపు రుజువు",
        platform_profile: "స్కామర్ ప్రొఫైల్ లింక్‌లు",
        contract: "ఇన్‌వాయిస్ లేదా ఒప్పందం",
      },
    },
    admin: {
      title: "అడ్మిన్ ప్యానెల్",
      subtitle: "CHINTAMAT యూజర్లు, స్కామ్ రిపోర్ట్లు, చట్టపరమైన సహాయం, బ్లాగ్ నిర్వహించండి.",
      loading: "లోడ్ అవుతోంది…",
      refresh: "రిఫ్రెష్",
      overview: "అవలోకనం",
      users: "యూజర్లు",
      scamReports: "స్కామ్ రిపోర్ట్లు",
      legalHelp: "చట్టపరమైన సహాయం",
      blog: "బ్లాగ్",
      allStatuses: "అన్ని స్థితులు",
      allCategories: "అన్ని వర్గాలు",
      category: "వర్గం",
      searchLegal: "ఇమెయిల్, పేరు, నష్టం రకం శోధన…",
      noLegal: "చట్టపరమైన అభ్యర్థనలు లేవు.",
      contact: "సంప్రదింపు",
      lossType: "నష్టం రకం",
      amount: "మొత్తం",
      status: "స్థితి",
      submitted: "సమర్పించబడింది",
      actions: "చర్యలు",
      view: "చూడండి",
      legalDetail: "చట్టపరమైన సహాయం అభ్యర్థన",
      adminNotes: "అడ్మిన్ నోట్స్",
      saveNotes: "నోట్స్ సేవ్",
      markResolved: "పరిష్కరించబడింది",
      closeRequest: "మూసివేయి",
      statusUpdated: "స్థితి నవీకరించబడింది",
      notesSaved: "నోట్స్ సేవ్",
      changeStatus: "స్థితి మార్చు",
      pendingLegal: "పెండింగ్",
      reportsSection: "రిపోర్ట్లు & మెంటర్లు",
      contentSection: "కంటెంట్ & ఇన్‌బాక్స్",
      usersSection: "యూజర్లు",
      total: "మొత్తం",
      individuals: "వ్యక్తులు",
      mentors: "మెంటర్లు",
      advisories: "ఎడ్వైజరీలు",
      admins: "అడ్మిన్లు",
      blocked: "బ్లాక్",
      reports: "రిపోర్ట్లు",
      pending: "పెండింగ్",
      published: "ప్రచురించబడింది",
      totalLoss: "మొత్తం నష్టం (₹)",
      acrossReports: "అన్ని రిపోర్ట్లలో",
      verified: "ధృవీకరించబడింది",
      flagged: "ఫ్లాగ్",
      reviews: "రివ్యూలు",
      articles: "వ్యాసాలు",
      contactMessages: "సంప్రదింపు సందేశాలు",
      legalRequests: "చట్టపరమైన అభ్యర్థనలు",
      legalStatus: legalStatusLabels.te,
    },
    mentors: {
      title: "మెంటర్ డైరెక్టరీ",
      subtitle: "చెల్లింపు ముందు మెంటర్లను తనిఖీ చేయండి. రివ్యూలు నమోదిత యూజర్ల నుండి — SEBI నమోదును స్వతంత్రంగా ధృవీకరించండి.",
      search: "పేరు, కంపెనీ, నగరం శోధన…",
      category: "వర్గం",
      allCategories: "అన్ని వర్గాలు",
      verification: "ధృవీకరణ",
      all: "అన్నీ",
      verifiedOnly: "ధృవీకరించబడినవి మాత్రమే",
      unverified: "ధృవీకరించబడలేదు",
      sortTrust: "అత్యధిక నమ్మకం",
      sortReviews: "ఎక్కువ రివ్యూలు",
      sortRecent: "ఇటీవలి",
      noResults: "మెంటర్లు కనిపించలేదు.",
      viewProfile: "ప్రొఫైల్",
      reviews: "రివ్యూలు",
    },
    blog: {
      title: "బ్లాగ్ — నిజ కేసులు, చట్టపరమైన మార్గదర్శనం",
      subtitle: "ధృవీకరించబడిన బాధితుల అనుభవాలు మరియు చట్టపరమైన ఫైలింగ్ దశలు.",
    },
    protected: { loading: "సెషన్ తనిఖీ…", adminLoading: "అడ్మిన్ తనిఖీ…" },
  },
  ta: {
    lang: { choose: "மொழியைத் தேர்ந்தெடுக்கவும்" },
    lossCategories: {
      eyebrow: "உங்கள் பாதையைத் தேர்ந்தெடுக்கவும்",
      title: "எந்த நிதி இழப்புக்கு எதிராக போராடுகிறீர்கள்?",
      subtitle: "சரியான அதிகாரத்தைக் கண்டறியுங்கள். சரியான சான்றுகளைத் தயாரியுங்கள். சரியான அடுத்த படியை எடுங்கள்.",
      authorityLabel: "எங்கே புகாரளிக்க வேண்டும்",
      items: [
        { key: "trading", title: "வர்த்தகம் & முதலீட்டு மோசடி", desc: "தரகர்கள், ஆலோசகர்கள், டெலிகிராம் டிப்ஸ், போலி டீமேட் கையாளுதல், உத்தரவாத வருமான திட்டங்கள்.", authority: "SEBI SCORES / SMART ODR" },
        { key: "consumer", title: "நுகர்வோர் பொருள் & சேவை", desc: "குறைபாடுள்ள பொருட்கள், குறைபாடுள்ள சேவைகள் மற்றும் நியாயமற்ற வர்த்தக நடைமுறைகள்.", authority: "தேசிய நுகர்வோர் ஹெல்ப்லைன்" },
        { key: "airline", title: "விமான பணத்திருப்பம் & தாமதம்", desc: "பணத்திருப்பம், ரத்து, விமான தாமதம் மற்றும் தொலைந்த/சேதமான பயணப்பை.", authority: "AirSewa / DGCA" },
        { key: "banking", title: "வங்கி, UPI, கார்டு & கடன்", desc: "அங்கீகரிக்கப்படாத பற்றுகள், UPI மோசடி, கார்டு தவறான பயன்பாடு, கடன் & NBFC சர்ச்சைகள்.", authority: "RBI" },
        { key: "cyber", title: "சைபர் மோசடி & மோசடி பணம்", desc: "ஆன்லைன் மோசடிகள், ஃபிஷிங், மோசடி பரிமாற்றங்கள் மற்றும் டிஜிட்டல் பணப் பரிமாற்ற மோசடி.", authority: "சைபர் கிரைம் போர்டல் / 1930" },
        { key: "insurance", title: "காப்பீட்டு உரிமைகோரல் சர்ச்சை", desc: "நிராகரிக்கப்பட்ட உரிமைகோரல்கள், தவறான விற்பனை, தாமதமான தீர்வுகள் மற்றும் பாலிசி புகார்கள்.", authority: "IRDAI" },
        { key: "housing", title: "வீட்டு நிதி புகார்கள்", desc: "வீட்டுக் கடன் மற்றும் வீட்டு நிதி நிறுவன புகார்கள்.", authority: "NHB" },
        { key: "pension", title: "ஓய்வூதிய புகார்கள்", desc: "NPS, ஓய்வூதிய கணக்கு மற்றும் ஓய்வூதிய நிதி தொடர்பான சிக்கல்கள்.", authority: "PFRDA" },
      ],
    },
    auth: {
      welcomeBack: "மீண்டும் வரவேற்கிறோம்",
      signInSubtitle: "விமர்சனங்கள், வழக்குகள், மென்டர்களை சேமிக்க உள்நுழையுங்கள்.",
      joinTitle: "CHINTAMAT இல் சேருங்கள்",
      joinSubtitle: "மோசடி அறிக்கை, சட்ட உதவி, மென்டர் அடைவுக்கு கணக்கு உருவாக்குங்கள்.",
      email: "மின்னஞ்சல்",
      password: "கடவுச்சொல்",
      name: "முழு பெயர்",
      signIn: "உள்நுழை",
      signUp: "கணக்கு உருவாக்கு",
      continueGoogle: "Google உடன் தொடரவும்",
      orEmail: "அல்லது மின்னஞ்சல்",
      newHere: "CHINTAMAT இல் புதியவரா?",
      haveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
      createAccount: "கணக்கு உருவாக்கு",
      gotoSignIn: "உள்நுழை",
      passwordMin: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள்",
      roleUser: "தனிநபர்",
      roleUserDesc: "வர்த்தகர் / பாதிக்கப்பட்டவர் — அறிக்கை அல்லது ஆராய்ச்சி.",
      roleMentor: "மென்டர் / கல்வியாளர்",
      roleMentorDesc: "பாடநெறி, சேனல் அல்லது கட்டண மென்டர்‌ஷிப்.",
      roleAdvisory: "ஆராய்ச்சி ஆலோசகர்",
      roleAdvisoryDesc: "SEBI பதிவு RIA, RA அல்லது நிறுவனம்.",
      verifying: "அமர்வு சரிபார்ப்பு…",
      adminRequired: "நிர்வாக அணுகல் தேவை.",
    },
    dashboard: {
      eyebrow: "என் டாஷ்போர்டு",
      hello: "வணக்கம்",
      adminPanel: "நிர்வாக பேனல்",
      adminDesc: "பயனர்கள், மோசடி அறிக்கைகள், சட்ட உதவி, வலைப்பதிவு நிர்வகம்.",
      openAdmin: "நிர்வாகம் திற",
      statReviews: "எழுதிய விமர்சனங்கள்",
      statCases: "அறிவித்த வழக்குகள்",
      statLegal: "சட்ட உதவி கோரிக்கைகள்",
      statSaved: "சேமித்த மென்டர்கள்",
      tabReviews: "என் விமர்சனங்கள்",
      tabCases: "என் வழக்குகள்",
      tabSaved: "சேமித்த மென்டர்கள்",
      tabLegal: "சட்ட உதவி",
      emptyReviews: "இன்னும் விமர்சனம் இல்லை.",
      browseMentors: "மென்டர்களைப் பார்",
      emptyCases: "இன்னும் வழக்கு இல்லை.",
      reportScam: "மோசடி அறிக்கை",
      emptySaved: "சேமித்த மென்டர் இல்லை.",
      discoverMentors: "மென்டர்களைக் கண்டறி",
      emptyLegal: "இன்னும் சட்ட கோரிக்கை இல்லை.",
      submitLegal: "கோரிக்கை அனுப்பு",
      agentContact: "முகவர் தொடர்பு பதிவு",
      viewProfile: "சுயவிவரம்",
      recentActivity: "சமீபத்திய புதுப்பிப்புகள்",
      openCase: "வழக்கைத் திற",
      prefsTitle: "அறிவிப்பு விருப்பங்கள்",
      prefsBlog: "புதிய வலைப்பதிவு & கல்வி கட்டுரைகள்",
      prefsCase: "வழக்கு நிலை & பணியாளர் பதில்",
      prefsSaved: "விருப்பங்கள் சேமிக்கப்பட்டன",
    },
    notifications: {
      title: "அறிவிப்புகள்",
      empty: "இன்னும் அறிவிப்புகள் இல்லை",
      markAllRead: "அனைத்தையும் படித்ததாகக் குறி",
      viewDashboard: "டாஷ்போர்டைத் திற",
      types: {
        case_status_change: { title: "{caseLabel} — நிலை புதுப்பிப்பு", body: "உங்கள் வழக்கு இப்போது: {status}" },
        case_staff_comment: { title: "CHINTAMAT இலிருந்து பதில்", body: "{authorName}: {preview}" },
        case_user_comment: { title: "பயனர் கருத்து — {caseLabel}", body: "{authorName}: {preview}" },
        new_scam_report: { title: "புதிய மோசடி அறிக்கை", body: "{scamType}" },
        new_legal_request: { title: "புதிய சட்ட உதவி கோரிக்கை", body: "{lossType} — {name}" },
        blog_published: { title: "புதிய கட்டுரை", body: "{articleTitle}" },
      },
    },
    caseWorkspace: {
      evidenceTitle: "சான்று சரிபார்ப்பு பட்டியல்",
      statusTimeline: "நிலை காலவரிசை",
      comments: "கருத்துகள்",
      sendMessage: "செய்தி அனுப்பு",
      postComment: "கருத்து இடு",
      noComments: "இன்னும் கருத்துகள் இல்லை. CHINTAMAT பணியாளர் இங்கே பதிலளிப்பார்.",
      loading: "வழக்கு ஏற்றுகிறது…",
      checklist: {
        screenshots: "அரட்டை அல்லது ஸ்கிரீன்ஷாட்",
        payment_proof: "UPI / வங்கி கட்டண சான்று",
        platform_profile: "மோசடியாளர் சுயவிவர இணைப்புகள்",
        contract: "விலைப்பட்டியல் அல்லது ஒப்பந்தம்",
      },
    },
    admin: {
      title: "நிர்வாக பேனல்",
      subtitle: "CHINTAMAT பயனர், மோசடி அறிக்கை, சட்ட உதவி, வலைப்பதிவு நிர்வகம்.",
      loading: "ஏற்றுகிறது…",
      refresh: "புதுப்பி",
      overview: "கண்ணோட்டம்",
      users: "பயனர்கள்",
      scamReports: "மோசடி அறிக்கைகள்",
      legalHelp: "சட்ட உதவி",
      blog: "வலைப்பதிவு",
      allStatuses: "அனைத்து நிலைகள்",
      allCategories: "அனைத்து வகைகள்",
      category: "வகை",
      searchLegal: "மின்னஞ்சல், பெயர், இழப்பு வகை தேடு…",
      noLegal: "சட்ட கோரிக்கைகள் இல்லை.",
      contact: "தொடர்பு",
      lossType: "இழப்பு வகை",
      amount: "தொகை",
      status: "நிலை",
      submitted: "சமர்ப்பிக்கப்பட்டது",
      actions: "செயல்கள்",
      view: "காண்",
      legalDetail: "சட்ட உதவி கோரிக்கை",
      adminNotes: "நிர்வாக குறிப்புகள்",
      saveNotes: "குறிப்புகள் சேமி",
      markResolved: "தீர்க்கப்பட்டது",
      closeRequest: "மூடு",
      statusUpdated: "நிலை புதுப்பிக்கப்பட்டது",
      notesSaved: "குறிப்புகள் சேமிக்கப்பட்டன",
      changeStatus: "நிலை மாற்று",
      pendingLegal: "நிலுவையில்",
      reportsSection: "அறிக்கைகள் & மென்டர்கள்",
      contentSection: "உள்ளடக்கம் & இன்பாக்ஸ்",
      usersSection: "பயனர்கள்",
      total: "மொத்தம்",
      individuals: "தனிநபர்கள்",
      mentors: "மென்டர்கள்",
      advisories: "ஆலோசனை",
      admins: "நிர்வாகிகள்",
      blocked: "தடுக்கப்பட்டது",
      reports: "அறிக்கைகள்",
      pending: "நிலுவை",
      published: "வெளியிடப்பட்டது",
      totalLoss: "மொத்த இழப்பு (₹)",
      acrossReports: "அனைத்து அறிக்கைகளிலும்",
      verified: "சரிபார்க்கப்பட்டது",
      flagged: "குறிக்கப்பட்டது",
      reviews: "விமர்சனங்கள்",
      articles: "கட்டுரைகள்",
      contactMessages: "தொடர்பு செய்திகள்",
      legalRequests: "சட்ட கோரிக்கைகள்",
      legalStatus: legalStatusLabels.ta,
    },
    mentors: {
      title: "மென்டர் அடைவு",
      subtitle: "பணம் செலுத்தும் முன் மென்டர்களை சரிபார்க்கவும். விமர்சனங்கள் பதிவு பயனர்களிடமிருந்து — SEBI பதிவை சுயமாக சரிபார்க்கவும்.",
      search: "பெயர், நிறுவனம், நகரம் தேடு…",
      category: "வகை",
      allCategories: "அனைத்து வகைகள்",
      verification: "சரிபார்ப்பு",
      all: "அனைத்தும்",
      verifiedOnly: "சரிபார்க்கப்பட்டவை மட்டும்",
      unverified: "சரிபார்க்கப்படவில்லை",
      sortTrust: "அதிக நம்பிக்கை",
      sortReviews: "அதிக விமர்சனம்",
      sortRecent: "சமீபத்தியது",
      noResults: "மென்டர் பொருந்தவில்லை.",
      viewProfile: "சுயவிவரம்",
      reviews: "விமர்சனங்கள்",
    },
    blog: {
      title: "வலைப்பதிவு — உண்மை வழக்குகள், சட்ட வழிகாட்டி",
      subtitle: "சரிபார்க்கப்பட்ட பாதிக்கப்பட்டவர்களின் அனுபவங்கள் மற்றும் சட்ட புகார் படிகள்.",
    },
    protected: { loading: "அமர்வு சரிபார்ப்பு…", adminLoading: "நிர்வாக சரிபார்ப்பு…" },
  },
};
